/**
 * The install method for the Live Chat Vue plugin (Tawk.to only).
 * @param {import('vue').App} app
 * @param {object} options
 * @param {string} options.chatEnabled - Whether chat is enabled ('true' or 'false')
 * @param {string} options.talkToSrc - The script URL for Tawk.to
 */
export function installLiveChat(app, options) {
	const { chatEnabled, talkToSrc } = options;

	if (chatEnabled === 'true') {
		// Load Tawk.to script
		window.Tawk_API = window.Tawk_API || {};
		window.Tawk_LoadStart = new Date();
		const htmlDir = document.documentElement.getAttribute('dir');
		console.log(htmlDir);
		const isRTL = htmlDir === 'rtl';

		window.Tawk_API.customStyle = {
			zIndex: 9996,
			visibility: {
				mobile: {
					position: isRTL ? 'bl' : 'br',
					xOffset: isRTL ? '10px' : '0px',
					yOffset: '90px'
				},
				desktop : {
					position: isRTL ? 'bl' : 'br',
					xOffset: isRTL ? '10px' : '0px',
					yOffset : 50
				},

			}
		};

		const cleanupAfterTawk = () => {
			const body = document.body;
			const html = document.documentElement;

			body.style.removeProperty('position');
			body.style.removeProperty('top');
			body.style.removeProperty('left');
			body.style.removeProperty('right');
			body.style.removeProperty('width');
			body.style.removeProperty('height');
			body.style.removeProperty('min-height');
			body.style.removeProperty('max-height');
			body.style.removeProperty('max-width');
			body.style.removeProperty('overflow');

			html.style.removeProperty('overflow');
			html.style.removeProperty('height');

			if (location.hash === '#max-widget') {
				history.replaceState(null, document.title, location.pathname + location.search);
			}

			const y = window.scrollY || window.pageYOffset || 0;
			requestAnimationFrame(() => {
				window.scrollTo(0, y + 1);
				requestAnimationFrame(() => window.scrollTo(0, y));
			});

			setTimeout(() => window.dispatchEvent(new Event('resize')), 0);
		};

		window.Tawk_API.onChatMaximized = function () {
			// window.Tawk_API.isOpen = true;

			let betslip_modal = document.querySelector('.eventime_mobal_content.form-popup');
			if (betslip_modal) betslip_modal.style.zIndex = 249;
		};
		window.Tawk_API.onChatMinimized = function () {
			// window.Tawk_API.isOpen = false;
			let betslip_modal = document.querySelector('.eventime_mobal_content.form-popup');
			if (betslip_modal) betslip_modal.style.zIndex = 9997;
			cleanupAfterTawk();
		};

		const s1 = document.createElement('script');
		const s0 = document.getElementsByTagName('script')[0];
		s1.async = true;
		s1.src = talkToSrc;
		s1.setAttribute('crossorigin', '*');
		s0.parentNode.insertBefore(s1, s0);
		console.log('Tawk.to chat loaded.');
	}

	// Optional configuration hook for future use
	app.config.globalProperties.$configureLiveChat = () => {
		console.log('Live chat configured (Tawk.to only).');
	};
}